// IMPORT REACT
import React from "react";

// IMPORT COMPONENTS
import YAHeader from '../../components/Header';

// IMPORT STYLES
// import { Sc_Container  } from '../styles';

function Loading() {
  return (
    <div>
      <YAHeader>
        
      </YAHeader>
    </div>
  );
}

export default Loading;